import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import tableAppBlackoutsPostalCodesCatalog from './tableAppBlackoutsPostalCodesCatalog';

export default {
  title: 'General',
  attributeName: 'postalcodes',
  fields: [
    {
      attributeName: 'name',
      helpText: 'Name of the rule',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Name',
      placeholder: 'Name...',
    },
    {
      attributeName: 'countryId',
      helpText: 'Country',
      type: FormInputTypes.SELECT,
      label: 'Country',
      placeholder: 'Please enter to add Country ...',
      multiple: false,
      url: 'countrieslist',
      emptyValue:true,
      default:'(Empty)', //default value to empty option
      fieldValue:'id',
      fieldName:'name',
      asyncSelect: true,
      options:[]
    },
    {
      attributeName: 'postalCodes',
      helpText: 'PostalCodes must have only alphanumeric chars or spaces separated by comma',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Postal Codes',
      placeholder: 'Postal codes...',
      multiline:true,
      importButton:'Load groups',
      configFileImport:tableAppBlackoutsPostalCodesCatalog,
      fieldToImport:'postalCodes',
    },
  ],
};
